"use strict";

angular
    .module(ApplicationConfiguration.applicationModuleName)
    .controller(
        "userInviteCtrl",
        function (
            $scope,
            $rootScope,
            $state,
            $filter,
            $localStorage,
            User,
            MessageService,
            enumerators
        ) {
            var vm = this;

            var $translate = $filter("translate");

            angular.extend($scope.$parent.vm, {
                title: "users.settings.titleNewInvite",
                insertUrl: null,
            });

            vm.isChatOpened = false;
            vm.userId = $localStorage.userId;
            $scope.uploader = {};

            // INICIALIZAÇÕES
            $rootScope.laddaLoading = false;

            vm.newInvitation = function () {
                vm.model.email = "";
                $("#modalInvite").modal("hide");
            };

            vm.submit = function () {
                $rootScope.laddaLoading = true;
                User.invite(
                    vm.model,
                    function (response) {
                        $("#modalInvite").modal("show");
                    },
                    function (response) {
                        MessageService.alertError(response.data);
                    }
                );
                $rootScope.laddaLoading = false;
            };
        }
    );
